import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Signup route removed — SendMe is Google-only now.
// Redirect any legacy /register traffic (or bookmarks) to /login,
// preserving the `next` query string when present.
export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const next = new URLSearchParams(location.search).get("next");
    navigate(next ? `/login?next=${encodeURIComponent(next)}` : "/login", { replace: true });
  }, [navigate, location.search]);
  return null;
}
